import { Link } from "react-router-dom"
import { FiBell } from "react-icons/fi"
import { useUnreadMessages } from "../../hooks/useUnreadMessages"

// Bell in the top bar: shows how many messages are unread and opens the inbox
export default function MessageBell() {
  const unread = useUnreadMessages()

  return (
    <Link
      to="/messages"
      aria-label={unread > 0 ? `Messages, ${unread} unread` : "Messages"}
      title="Messages"
      className="relative flex h-11 w-11 items-center justify-center rounded-[10px] border border-appLine bg-white text-dantzBlue transition-colors hover:bg-appBg"
    >
      <FiBell size={20} />
      {unread > 0 && (
        <span className="absolute -right-1 -top-1 min-w-[1.1rem] rounded-full border-2 border-white bg-dantzOrange px-1 text-center text-[11px] font-medium leading-[0.9rem] text-white">
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </Link>
  )
}
